import * as React from 'react';
import { Field as FinalField } from 'react-final-form';
import { CheckboxGroup, CheckboxGroupItemProps } from '@lendi-ui/checkbox';
import Field from '@lendi-ui/field';

import { FieldLabel } from '../../../Fields';
import { FieldWrapper } from '../../../Fields/_common/style';
import { CommonFieldProps } from '../../../Fields/_common/types';

interface CheckboxFieldProps extends CommonFieldProps, Omit<CheckboxGroupItemProps, 'label'> {
  checkboxLabel?: string;
  value: string;
}

export const NeedsAndAnalysisCheckboxField: React.FC<CheckboxFieldProps> = (props) => {
  const {
    label,
    labelAfter,
    name,
    subLabel,
    disableFailMessage = false,
    checkboxLabel,
    value,
    isDisabled,
    ...rest
  } = props;

  const fieldProps = {
    name,
  };

  // isDisabled is CheckboxGroup.Checkbox is not working
  const restProps = { ...rest, disabled: isDisabled };

  return (
    <FieldWrapper>
      <FieldLabel label={label} labelAfter={labelAfter} subLabel={subLabel} />
      <FinalField {...fieldProps}>
        {({ input, meta }) => (
          <Field {...meta} error={disableFailMessage ? undefined : meta.error}>
            <CheckboxGroup.Checkbox
              {...restProps}
              value={value}
              label={checkboxLabel}
              data-component={name}
              isDisabled={isDisabled}
            />
          </Field>
        )}
      </FinalField>
    </FieldWrapper>
  );
};
